module.exports = __webpack_public_path__ + "static/img/A123.284580fb.jpg";